import { Avatar, Tag } from "antd";
import { useTranslation } from "react-i18next";

type PartnerCardVariant = "normal" | "pending" | "disabled";

function PartnerCard({
  partner,
  onClick,
  variant = "normal",
}: {
  partner: any;
  onClick: () => void;
  variant?: PartnerCardVariant;
}) {
  const { t } = useTranslation();
  const muted = variant !== "normal";
  const name: string = partner?.name || "";
  const contactName: string = partner?.contacts?.[0]?.name || "";
  const telephone: string = partner?.telephone || "";
  const businessIdNumber: string = partner?.businessIdNumber || "";

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 16,
        padding: 16,
        backgroundColor: muted ? "#fafafa" : "#f5f5f5",
        borderRadius: 8,
        cursor: "pointer",
        transition: "background-color 0.2s",
        opacity: muted ? 0.7 : 1,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = muted ? "#f0f0f0" : "#e8e8e8";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = muted ? "#fafafa" : "#f5f5f5";
      }}
    >
      <Avatar
        size={56}
        style={{
          backgroundColor: muted ? "#bfbfbf" : "#d9d9d9",
          color: "#666",
          fontSize: 20,
          fontWeight: 500,
          flexShrink: 0,
        }}
      >
        {name.slice(0, 1)}
      </Avatar>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            overflow: "hidden",
          }}
        >
          <span
            style={{
              fontWeight: 600,
              fontSize: 14,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: muted ? "#999" : undefined,
            }}
          >
            {name}
          </span>
          {variant === "pending" && (
            <Tag color="warning" style={{ fontSize: 11, margin: 0, flexShrink: 0 }}>
              {t("coop.pending") || "審核中"}
            </Tag>
          )}
          {variant === "disabled" && (
            <Tag style={{ fontSize: 11, margin: 0, flexShrink: 0 }}>
              {t("coop.inactive") || "停用"}
            </Tag>
          )}
        </div>
        <div
          style={{
            fontSize: 13,
            color: "#999",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {`${t("coop.businessIdNumber") || "統編"} ${businessIdNumber}`}
          {contactName ? ` · ${contactName}` : ""}
        </div>
        <div style={{ fontSize: 13, color: muted ? "#bfbfbf" : "#1677ff" }}>
          {telephone}
        </div>
      </div>
    </div>
  );
}

export default PartnerCard;
